// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyAvailabilityV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyAvailabilityConfirmResponseV2WebDto,
  UserPropertyAvailabilityConfirmV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Args {
  postData: UserPropertyAvailabilityConfirmV2RequestDto;
}

export type RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Options = UseMutationOptions<
  UserPropertyAvailabilityConfirmResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Args
>;

/**
 * Confirm listing availability
 */
export const useRentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm_Args) =>
      RentalManagerUserPropertyAvailabilityV2WebApiHandler_confirm(args.postData, httpClient),
  });
};
